export default __webpack_public_path__ + "static/media/PLANTA_DE_MANI.dcfbab1f.obj";